import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import ToolsHelper from '@core/services/tools.helper';

@Component({
  name: 'bpc-display-field-amount',
  components: {},
})
export default class DisplayFieldAmount extends mixins(AbstractDisplayField) {
  showWithBadge = this.fieldConfig.showWithBadge || false;
  valueBadgeField = this.fieldConfig.valueBadgeField || null;
  valueBadgeToLabel = this.fieldConfig.valueBadgeToLabel || null;
  valueBadgeToVariant = this.fieldConfig.valueBadgeToVariant || null;

  get valueBadge() {
    if (!!this.item && this.valueBadgeField) {
      return this.item[this.valueBadgeField];
    }
    return null;
  }

  get valueBadgeLabel() {
    if (this.valueBadgeToLabel) {
      const item = this.valueBadgeToLabel.find(item => item.value === this.valueBadge);
      return item?.label;
    }
    return null;
  }

  get valueBadgeVariant() {
    if (this.valueBadgeToVariant) {
      const item = this.valueBadgeToVariant.find(item => item.value === this.valueBadge);
      return item?.variant;
    }
    return null;
  }

  formatPrice(value: string) {
    if (!value) {
      return '';
    } else {
      return ToolsHelper.formatPrice(value);
    }
  }
}
